import React from 'react';
import './NumOfVideosOfEahResto.css';
import waves from '../../../assets/waves.png';

// `data` is the consolidated partner dashboard payload fetched once by Home.
export const NumOfVideosOfEahResto = ({ data }) => {
  const restaurants = Array.isArray(data?.restaurants) ? data.restaurants : [];
  const socialLinks = Array.isArray(data?.socialLinks) ? data.socialLinks : [];

  return (
    <>
      {/* ————— Restaurant Cards Container ————— */}
      <div className="num-of-videos-container">
        {restaurants.map((restaurant) => (
          <div
            key={restaurant._id}
            className="restaurant-card complex-dark-theme"
            style={{ backgroundImage: `url(${waves})`, backgroundSize: 'cover' }}
          >
            <div className="restaurant-name">{restaurant.name}</div>
            <div className="restaurant-email">{restaurant.email}</div>
            <div className="restaurant-phone">{restaurant.phone}</div>
            <div className="restaurant-location">{restaurant.location}</div>
            <div className="winned-vouchers">
              Redeemed Vouchers:
              <br />
              <span
                style={{
                  fontSize: 42,
                  color: '#fff',
                  fontWeight: 'bold',
                  fontStyle: 'italic'
                }}
              >
                {restaurant.partnerRedeemedVouchers ?? 0}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* ————— Social Links Container (always on its own line) ————— */}
      {socialLinks.length > 0 && (
        <div className="social-links-container">
          {socialLinks.map((linkObj) => {
            const clicks = typeof linkObj.clicks === 'number' ? linkObj.clicks : 0;
            return (
              <div key={linkObj._id} className="social-link-card complex-dark-theme" style={{ backgroundImage: `url(${waves})`, backgroundSize: 'cover' }}>
                <div className="link-name">{linkObj.name}</div>
                <div className="link-clicks">
                  {clicks} click{clicks !== 1 ? 's' : ''}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default NumOfVideosOfEahResto;
